<template>
  <div>
    <form @submit.prevent="() => {}">
      <br />
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <md-card class="md-layout-item">
            <md-card-header>
              <div class="md-title">Adicionar</div>
            </md-card-header>

            <md-card-content>
              <input
                ref="file"
                class="md-button md-primary md-raised inputfile"
                type="file"
                multiple
                @change="adicionarFotos"
              />
              <md-button
                class="md-button md-primary md-raised"
                @click="() => uploadFiles()"
              >
                Salvar arquivos
              </md-button>

              <br />
              <br />
              <md-divider />

              <div>
                <div class="row">
                  <div
                    v-for="(foto, i) in arquivosSalvar"
                    :key="i"
                    class="col-6"
                  >
                    <md-button
                      class="md-icon-button md-list-action"
                      @click="() => removerFoto(i)"
                    >
                      <md-icon>clear</md-icon>
                    </md-button>
                    <img :src="foto.reader.result" />
                  </div>
                </div>
              </div>
            </md-card-content>

            <md-card-header>
              <div class="md-title">Ordem</div>
              <span class="md-subheading"
                >Valores maiores serão representado pelas imagens/gifs mais
                acima</span
              >
            </md-card-header>
            <md-card-content>
              <div v-for="file in files" :key="file.id">
                <md-divider class="m-2" />
                <div class="md-layout">
                  <div
                    class="md-layout-item md-size-5"
                    style="text-align: center"
                  >
                    <md-button
                      class="md-icon-button md-list-action"
                      style="margin-left: 0"
                      @click="() => changePosition(file.id, 'up')"
                    >
                      <md-icon>arrow_upward</md-icon>
                    </md-button>

                    <md-button
                      class="md-icon-button md-list-action"
                      @click="() => (deleteFileId = file.id)"
                    >
                      <md-icon>delete</md-icon>
                    </md-button>

                    <md-button
                      class="md-icon-button md-list-action"
                      @click="() => changePosition(file.id, 'down')"
                    >
                      <md-icon>arrow_downward</md-icon>
                    </md-button>
                  </div>

                  <div class="md-layout-item md-size-95">
                    <img :src="file.url" />
                  </div>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </form>

    <md-dialog-confirm
      :md-backdrop="true"
      :md-active="deveAbrirModalDeleteFile"
      md-title="Tem certeza?"
      md-content="Deletar um arquivo não pode ser desfeito."
      md-confirm-text="deletar"
      md-cancel-text="cancelar"
      @md-clicked-outside="deleteFileId = null"
      @md-cancel="deleteFileId = null"
      @md-confirm="() => deletarGraphical()"
    />
  </div>
</template>

<script>
import { EventBus, Topics, Types } from '../../../event-bus'
import http from '../../../utils/http'

export default {
  name: 'GraphicalViewFile',
  data() {
    return {
      multiple: null,
      arquivosSalvar: [],
      graphicalViewId: null,
      files: [],
      deleteFileId: null,
    }
  },
  computed: {
    deveAbrirModalDeleteFile() {
      return this.deleteFileId !== null
    },
  },
  beforeMount() {
    this.graphicalViewId = this.$route.params.graphicalId

    this.loadFiles()
  },
  methods: {
    async changePosition(id, direction) {
      let changePosition

      switch (direction) {
        case 'up':
          changePosition = 1
          break
        case 'down':
          changePosition = 0
          break
        default:
          console.error('Direção inválida')
          return
      }

      await http.put(
        `/graphical-view/${this.graphicalViewId}/file/${id}/position`,
        {
          changePosition: changePosition,
        }
      )

      this.loadFiles()
    },
    async deletarGraphical() {
      await http.delete(
        `/graphical-view/${this.graphicalViewId}/file/`,
        this.deleteFileId
      )

      this.files = this.files.filter((file) => file.id !== this.deleteFileId)
      this.deleteFileId = null
    },
    loadFiles() {
      http.get(`/graphical-view/${this.graphicalViewId}`).then((response) => {
        this.files = response.files
      })
    },
    async uploadFiles() {
      if (this.arquivosSalvar.length === 0) {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Não há arquivos para serem salvos.',
        })
      }

      const filesOrdered = [...this.arquivosSalvar].sort((a, b) =>
        a.file.name.localeCompare(b.file.name)
      )

      const responseIdFile = []

      for (const e of filesOrdered) {
        const responseId = await http.post(
          `graphical-view/${this.graphicalViewId}/file`,
          {},
          false
        )
        responseIdFile.push([responseId, e])
      }

      const promises = responseIdFile.map(async ([responseId, e]) => {
        const form = new FormData()
        form.append('file', e.file)

        await http.postForm(
          `graphical-view/${this.graphicalViewId}/file/${responseId}/link`,
          form,
          false
        )
      })

      EventBus.$emit(Topics.NOTIFICATIONS, {
        type: Types.INFO,
        message: 'Arquivos salvos',
      })

      await Promise.all(promises)

      this.arquivosSalvar = []
      this.loadFiles()
    },
    removerFoto: function (index) {
      this.arquivosSalvar.splice(index, 1)
    },
    adicionarFotos(event) {
      for (let i = 0; i < event.target.files.length; i++) {
        const reader = new FileReader()

        reader.onload = () => {
          this.arquivosSalvar.push({
            reader: reader,
            file: event.target.files[i],
            extension: event.target.files[i].name.split('.').pop(),
          })
        }

        reader.readAsDataURL(event.target.files[i])
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.inputfile {
  min-width: 25% !important;
}
</style>
